import Barcode from 'react-barcode';
import React from 'react';
export const RNBarcode = (props: any) => {
  return <Barcode displayValue={false} {...props} />;
};
